<section class="flex-1 bg-white">
    <div class="max-w-[1400px] mx-auto px-6 py-16 flex flex-col lg:flex-row items-center gap-16">

        <!-- Left Column: Login Form -->
        <div class="lg:w-1/2 w-full">
            <div class="flex items-center gap-4 self-stretch bg-app-background-20 px-4 py-4">
                <div class="text-sm tracking-wider font-light gap-2 flex">
                    Sie haben noch kein Konto? <a routerLink="/registrierung" class="text-app-secondary-10 font-semibold underline">Jetzt registrieren</a>
                </div>
            </div>
            <div class="font-fraunce text-5xl font-normal text-app-primary-20 my-12">Anmelden</div>

            <div class="space-y-6">
                <!-- Username -->
                <div class="flex flex-col gap-2">
                    <label class="text-app-primary-20">E-Mail</label>
                    <input type="email" matInput [formControl]="emailFormControl" [errorStateMatcher]="matcher"
                           placeholder="example@mail.de">
                </div>

                <!-- Password -->
                <div class="flex flex-col gap-2 relative">
                    <label class="text-app-primary-20">Passwort</label>
                    <div class="relative">
                        <input [type]="hidePassword ? 'password' : 'text'" matInput [formControl]="passwordFormControl"
                               [errorStateMatcher]="matcher" (keyup.enter)="onLogin()" placeholder="********">
                        <button (click)="hidePassword = !hidePassword"
                                class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-app-primary-10 cursor-pointer">
                            <i class="fa-solid" [ngClass]="{'fa-eye': !hidePassword, 'fa-eye-slash': hidePassword}"></i>
                        </button>
                    </div>
                    <button (click)="forgotPassword()" class="text-xs text-app-primary-20 hover:underline self-start">
                        Passwort vergessen?
                    </button>
                    <div class="text-sm text-gray-600 pt-8">
                        Probleme bei der Anmeldung?
                        <button (click)="openResendLinkModal()" class="text-app-primary-20 underline ml-1">Hier klicken</button>
                    </div>
                </div>

                <!-- Login Button -->
                <div class="pt-4 flex justify-end">
                    <button class="btn primary-button w-full sm:w-auto flex items-center justify-center gap-2" (click)="onLogin()">
                        Anmelden
                    </button>
                </div>

            </div>
        </div>

        <!-- Right Column: Benefits / Info -->
        <div class="lg:w-1/2 w-full rounded-2xl p-8 lg:p-12">
            <div
                class="grid grid-cols-1 sm:grid-cols-2 gap-y-12 gap-x-6">
                <!-- Vorteil 1 -->
                <div class="flex flex-col items-center text-center px-4 gap-2">
                    <div class="h-16 flex items-center justify-center">
                        <app-icon name="location-nope" class="w-[47px] h-[47px] text-app-secondary-10"/>
                    </div>
                    <div class="info-header">Keine vor-Ort-<br>Termine
                        notwendig
                    </div>
                    <div class="info-text">Gespräche bequem online<br>durchführen.</div>
                </div>

                <!-- Vorteil 2 -->
                <div class="flex flex-col items-center text-center px-4 gap-2">
                    <div class="h-16 flex items-center justify-center">
                        <app-icon name="user-shield" class="w-[47px] h-[47px] text-app-secondary-10"/>
                    </div>
                    <div class="info-header">Diskrete & flexible<br>Beratung</div>
                    <div class="info-text">Bei uns sind Ihre Daten<br>sicher.</div>
                </div>

                <!-- Vorteil 3 -->
                <div class="flex flex-col items-center text-center px-4 gap-2">
                    <div class="h-16 flex items-center justify-center">
                        <app-icon name="recipe" class="w-[47px] h-[47px] text-app-secondary-10"/>
                    </div>
                    <div class="info-header">Digitale Rezept-<br>Ausstellung
                        möglich
                    </div>
                    <div class="info-text">Schnell, sicher und<br>rechtskonform.</div>
                </div>

                <!-- Vorteil 4 -->
                <div class="flex flex-col items-center text-center px-4 gap-2">
                    <div class="h-16 flex items-center justify-center">
                        <app-icon name="pharmacy" class="w-[47px] h-[47px] text-app-secondary-10"/>
                    </div>
                    <div class="info-header">Einlösung direkt bei<br>uns vor
                        Ort
                    </div>
                    <div class="info-text">Rezept einlösen und direkt<br>abholen.</div>
                </div>
            </div>
        </div>

    </div>
</section>
